export const scale = 1.5;

export const playerHeightPx = 24;
export const playerWidthPx = 24;
export const tileSizePx = 24;
